import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsRemain'
})
export class SecondsRemainPipe implements PipeTransform {

  transform(value: any): string {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = Math.floor((sec_num - (hours * 3600)) - (minutes * 60));

    return seconds > 9 ? `${seconds}` : `0${seconds}`;
  }

}
